export default __webpack_public_path__ + "static/media/icon-selected-visit.479006e0.svg";